<template>
  <div class="text-base md:text-sm font-medium text-gray-800">
    <slot />
  </div>
</template>
